import { useProductsBySlug } from '@gik/api/products/productsBySlug';
import { FetchProvider } from '@gik/core/components/DynamicComponent/FetchProvider';
import { withTitle } from '@gik/core/hocs/withTitle';
import type { Product } from '@gik/core/models/gik/Product';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import React from 'react';
import type { ProductSectionProps } from './ProductSection';
import { ProductSection } from './ProductSection';

function ProductSectionWithDataComp(props: ProductSectionProps) {
  const { productSlug } = props;
  const useProduct = () => {
    return useProductsBySlug({ slug: [productSlug], perPage: 1 });
  };

  return (
    <FetchProvider<Product[]>
      fetch={useProduct}
      loadingComponent={<ProductSection skeletons {...props} products={[]} />}
    >
      {({ data: products }) => {
        return withTitle(
          {
            title: products?.[0]?.name,
          },
          <ProductSection {...props} products={products} inkindRouteId={props.inkindRouteId} />
        );
      }}
    </FetchProvider>
  );
}

export const ProductSectionWithData = withComponentErrorBoundary(ProductSectionWithDataComp);
